export default function PHP_ftp_get() {
  return (
    <div>
      <h1>PHP_ftp_get</h1>
    </div>
  );
}
